import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import useCloseButtonTop from '../../../hooks/useCloseButtonTop'
import DashboardButton from '../../Menu/Remote/DashboardButton'

interface AbsoluteLargeClosingButtonProps {
  dashboardVisible: boolean
  zIndexClassname?: string
  customComponent?: boolean
  onClick: () => void
}

const AbsoluteLargeClosingButton = ({ dashboardVisible, zIndexClassname, customComponent, onClick }: AbsoluteLargeClosingButtonProps): JSX.Element => {
  const hideMenu = useSelector((state: RootState) => state.retorikReducer.configuration.hideMenu)
  const isMobile = useSelector((state: RootState) => state.viewReducer.isMobile)
  const useOldRemote = useSelector((state: RootState) => state.retorikReducer.configuration.useOldRemote)
  const top = useCloseButtonTop()
  const [hidden, setHidden] = useState<boolean>(false)

  const handleHideAndClose = (): void => {
    dashboardVisible && !customComponent && setHidden(true)
    onClick()
  }

  return isMobile ? (
    <React.Fragment />
  ) : useOldRemote ? (
    <div
      className={`rf-absolute ${hidden && 'rf-hidden'} rf-w-24 rf-flex rf-justify-center rf-right-0 ${zIndexClassname || 'rf-z-ui'}`}
      style={{
        top: hideMenu ? `calc(${top} - 6rem)` : top
      }}
    >
      <DashboardButton dashboardVisible={dashboardVisible} onClick={handleHideAndClose} />
    </div>
  ) : (
    <React.Fragment />
  )
}

export default AbsoluteLargeClosingButton
